import { render, staticRenderFns } from "./publicProp.vue?vue&type=template&id=b64af44a&scoped=true&"
import script from "./publicProp.vue?vue&type=script&lang=ts&"
export * from "./publicProp.vue?vue&type=script&lang=ts&"
import style0 from "./publicProp.vue?vue&type=style&index=0&id=b64af44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64af44a",
  null
  
)

export default component.exports